import { render, staticRenderFns } from "./MajAndNews.vue?vue&type=template&id=9dcdc78e&"
import script from "./MajAndNews.vue?vue&type=script&lang=js&"
export * from "./MajAndNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports